import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useBibliotecaContext } from "../../context/BibliotecaContext";

export function MunicipalityFilter() {
    const { t } = useTranslation();
    const { municipiosData, municipiosSelecionados, setMunicipiosSelecionados } = useBibliotecaContext();

    const options = municipiosData
        ? municipiosData.map((municipio) => ({
            label: `${municipio.nome}`,
            value: municipio.areaatuacao_id,
        }))
        : [];

    const selectAllOption = { label: "Todos - Selecionar todos", value: "*" };
    const allOptions = [selectAllOption, ...options];

    let valueParaOSelect;
    if (municipiosSelecionados.includes("*")) {
        valueParaOSelect = [selectAllOption];
    } else {
        valueParaOSelect = options.filter((option) =>
            municipiosSelecionados.includes(option.value)
        );
    }

    const handleChange = (selected, actionMeta) => {
        if (actionMeta.action === "select-option" && actionMeta.option.value === "*") {
            setMunicipiosSelecionados(["*"]);
            return;
        }

        if (!selected) {
            setMunicipiosSelecionados([]);
            return;
        }

        const newSelection = selected
            .filter((o) => o.value !== "*")
            .map((o) => o.value);

        setMunicipiosSelecionados(newSelection);
    };

    return (
        <div className="mt-4">
            <div className="mb-2">{t("biblioteca.city")}</div>
            <Select
                value={valueParaOSelect}
                isMulti
                name="cidades"
                options={allOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleChange}
                placeholder={t("biblioteca.selectCity")}
                noOptionsMessage={() => t("biblioteca.emptyCity")}
            />
        </div>
    );
}